import { useSnackbar } from "notistack";
import { Box, Paper, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import errorFormat from "../../utils/errorFormat";
import { useNavigate } from "react-router-dom";
import configUrls from "../../config/configUrls";
import { IStipoProcesso, TipoProcesso } from "../../types/tipoProcesso/TipoProcesso";
import { useCreateTipoProcesso1Mutation } from "./tipoProcessoApiSlice";
import { TipoProcessoForm } from "./TipoProcessoForm";


export const TipoProcessoCreate = () => {

    const [tipoProcesso, setTipoProcesso] = useState<TipoProcesso>(IStipoProcesso);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar()
    const [createTipoProcesso, status] = useCreateTipoProcesso1Mutation();
    const navigate = useNavigate();


    
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        const cursorPosition = e.target.selectionStart;

        setTipoProcesso((prev) => ({
            ...prev,
            [name]: value,
        }));

        // Aguarde até que o DOM seja atualizado
        setTimeout(() => {
            const input = e.target;
            input.setSelectionRange(cursorPosition, cursorPosition);
        }, 0);
    };



    async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();
        await createTipoProcesso(tipoProcesso);
    }

    useEffect(() => {
        if (status.isError) {
            enqueueSnackbar("Registro não incluído!", { variant: "error" })
            const erroReturn: string = errorFormat(status);
            enqueueSnackbar(erroReturn, { variant: "error" })
        }

        if (status.isSuccess) {
            enqueueSnackbar("Registro incluído!", { variant: "success" })
            navigate(configUrls.TIPO_PROCESSO_LIST_RT);
            // setTipoProcesso(IStipoProcesso);          

        }
    }, [status]);








    return (



        <>


            <Paper>

                <Typography variant="h6" component="h1" sx={{ padding: 2 }}>
                    Tipos de Processos
                </Typography>



                <TipoProcessoForm
                    data={tipoProcesso}
                    // isdisabled={status.isLoading}
                    //isLoading={status.isLoading}
                    handleSubmit={handleSubmit}
                    handleChange={handleChange}
                />

            </Paper>










        </>







    );










};

/*
 <TipoProcessoTurmaForm
                    tipoProcessoTurma={tipoProcessoTurmaState}
                    isdisabled={status.isLoading}
                    isLoading={status.isLoading}
                    handleSubmit={handleSubmit}
                    handleChange={handleChange}
                />
*/